import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';
import { BaseComponent } from './../../../core/components/base/base.component';
import { FeedbackService } from './../../../core/services/feedback.service';
import { redirectToLogin } from '../../../core/utils/login-redirect.util';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent extends BaseComponent implements OnInit {
  verificationToken!: string;
  isLoading = true;
  errorMessage: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
  }

  ngOnInit() {
    this.verificationToken = this.route.snapshot.paramMap.get('token') as string;
    if (this.verificationToken) {
      const sub = this.userService.verifyEmail(this.verificationToken)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.success) {
              this.showToastMessage('Email verified successfully!');
              // One navigation to a freshly loaded /login — see `redirectToLogin`.
              redirectToLogin();
            } else {
              this.errorMessage = response.message;
              this.showToastMessage(response.message);
            }
            sub.unsubscribe();
          },
          (error) => {
            this.isLoading = false;
            this.errorMessage = error.error.message || 'An error occurred during verification.';
            this.showToastMessage(this.errorMessage!);
            sub.unsubscribe();
          }
        );
    } else {
      this.isLoading = false;
      this.errorMessage = 'No verification token was provided. Please use the link sent in the MedicAI welcome email to verify your email address.';
      this.showToastMessage(this.errorMessage);
      setTimeout(() => {
        // One navigation to a freshly loaded /login — see `redirectToLogin`.
        redirectToLogin();
      }, 3000);
    }
  }
}
